import React, { useEffect, useState } from "react";
import PromotionSection from "./PromotionSection";
import { ASSETS_BASE_URL } from "constants";
import DownloadSection from "./DownloadSection";
import { isEmpty } from "lodash";
import { Col, Container, Row } from "react-bootstrap";

const S3_JSON_URL = `${process.env.REACT_APP_CMS_BASE_URL}/rize-promotions?populate=*&sort=createdAt:desc`;
// const S3_JSON_URL = `${ASSETS_BASE_URL}assets/json/rize_promo.json`;

const Promotions = () => {
  const [promotions, setPromotions] = useState([]);

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(S3_JSON_URL);
        if (!response.ok) {
          throw new Error("Failed to fetch promotions data");
        }
        const data = await response.json();
        setPromotions(data?.data);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, []);

  return (
    <>
      {promotions?.map((promo, index) => (
        <PromotionSection key={index} promoKey={index} {...promo} />
      ))}
      {isEmpty(promotions) && (
        <div className="empty-promotion">
          <Container>
            <Row>
              <Col
                md={6}
                className="d-flex align-items-center justify-content-center pt-5"
                data-aos="fade-up"
                data-aos-delay="150"
              >
                <div className="empty-promotion__text">
                  More campaigns are coming.
                  <br />
                  Watch this space!
                </div>
              </Col>
              <Col
                md={6}
                className="d-flex align-items-center justify-content-center"
                data-aos="fade-up"
              >
                <img
                  src="https://www.alrajhibank.com.my/assets/images/promotions/rize_no_promotions.svg"
                  alt="No promotions"
                  className="empty-promotion__img"
                />
              </Col>
            </Row>
          </Container>
          <img
            src="https://www.alrajhibank.com.my/assets/images/promotions/background_229.svg"
            className="empty-promotion__background"
          />
        </div>
      )}
      <DownloadSection />
    </>
  );
};

export default Promotions;
